import { GetUser } from "@redotech/account-common/user";
import { createContext } from "react";

export const UserCacheContext = createContext<Map<string, GetUser>>(new Map());
